export const onServiceWorkerUpdateReady = () => {
    // Notify user when a Service Worker update is available.
    const answer = window.confirm(
        `This application has been updated. Reload to display the latest version?`
    );
    if (answer) {
        window.location.reload();
    }
};
